module.exports = __webpack_public_path__ + "static/img/Advanced-Torso-CT2.ce070cd8.png";